import "./Badge.css";

const VARIANT_MAP = {
  new:        "badge-new",
  bestseller: "badge-best",
  sale:       "badge-sale",
  "hot deal": "badge-hot",
  "limited edition": "badge-limited",
  trending:   "badge-trending",
  clearance:  "badge-clearance",
  featured:   "badge-featured",
  preorder:   "badge-preorder",
  status:     "badge-status",
  verified:   "badge-verified",
  trust:      "badge-trust",
};

const Badge = ({ label, variant = null }) => {
  const cls = variant
    ? VARIANT_MAP[variant] || "badge-default"
    : VARIANT_MAP[label?.toLowerCase()] || "badge-default";

  return <span className={`badge ${cls}`}>{label}</span>;
};

export default Badge;
